export const HUNGARY = {
  alert: {
    alert: 'lat'
  },
  general: {
    kengur: 'Kengur',
    kengurFull: 'Határok Nélküli Kengur - Szerbia Matematikus Társasága'
  },
  meni: {
    homePage: 'Kezdőlap',
    listofStudents: 'Diákok listája',
    listofUser: 'Felhasználók listája',
    listofSchool: 'Iskolák listája',
    displayResults: 'Eredmények megjelenítése',
    user: 'Felhasználók',
    students: 'Diákok',
    school: 'Iskolák',
    complaints: 'Panaszok',
    location: 'Helyszínek',
    category: 'Kategóriák',
    reviewPapers: 'Munkák áttekintése',
    statistics: 'Statisztikák',
    resultsStatistics: 'Eredmények statisztikája',
    languageStatistics: 'Nyelvi statisztika',
    genderStatistics: 'Nem szerinti statisztika',
    classandCategoryStatistics: 'Osztály és kategória statisztika',
    addNewSchool: 'Új iskola hozzáadása',
    addNewStudent: 'Diák regisztrálása',
    printList: 'Lista nyomtatása',
    profile: 'Profil',
    menu: 'Menü',
    manage: 'Kezelés',
    data: 'Adatok',
    hello: 'Szia ',
    schools: 'Iskolák',
    listofSchools: 'Iskolák listája',
    signStudent: 'Diák regisztrálása',
    allStudents: 'Minden diák',
    results: 'Eredmények',
    complaintsForStudent: 'Panaszok',
    reviewComplaints: 'Panaszok áttekintése',
    newComplaints: 'Panasz benyújtása',
    settings: 'Beállítások',
    changePassword: 'Jelszó módosítása',
    logout: 'Kijelentkezés',
    users: 'Felhasználók',
    schoolWorkReview: 'Munkák áttekintése',
    importstudents: 'Excelből importálás'
  },
  tabs: {
    all_complaints: 'Összes panasz',
    unread_by_admin: 'Admin nem olvasta',
    unread_by_school: 'Iskola nem olvasta',
    admin_responses: 'Admin válaszai',
    unanswered_complaints: 'Meg nem válaszolt panaszok',
    finished_complaints: 'Lezárt panaszok',
    users: 'Felhasználók',
    allUsers: 'Minden felhasználó',
    teachers: 'Tanárok',
    admins: 'Adminisztrátorok',
    schools: 'Iskolák',
    dms: 'DMS',
    DMS: 'DMS'
  },
  status: {
    read: 'Olvasott',
    unread: 'Nem olvasott'
  },
  pagination: {
    rows_per_page: 'Sorok oldalanként:',
    of: ' /',
    more_than: 'több mint',
    moreThan: 'több mint',
    rowsPerPage: 'Sorok oldalanként',
    noRowsLabel: 'Nincs találat',
    footerRowSelected: 'Kiválasztott sor'
  },
  dialog: {
    read: 'Olvasott',
    unread: 'Nem olvasott',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    successfullyDeleted: 'Sikeresen törölve',
    schoolLabel: 'Iskola',
    submitButton: 'Új hozzáadása',
    editPayment: 'Fizetés szerkesztése',
    addPayment: 'Fizetés hozzáadása',
    payment: 'Fizetési nyilvántartás',
    studentNameLabel: 'Diák neve',
    genderLabel: 'Nem',
    categoryLabel: 'Kategória',
    addStudentTitle: 'Új diák hozzáadása',
    classGradeLabel: 'Osztály',
    professorLabel: 'Tanár',
    languageLabel: 'Nyelv',
    cancelButton: 'Mégse',
    submitButton: 'Hozzáadás',
    schoolName: 'Iskola neve',
    male: 'Férfi',
    female: 'Nő',
    serbian: 'Szerb (Cirill)',
    croatian: 'Horvát',
    hungarian: 'Magyar',
    latin: 'Szerb (Latin)',
    romanian: 'Román',
    nameRequired: 'Név megadása kötelező.',
    genderRequired: 'Nem megadása kötelező.',
    categoryRequired: 'Kategória megadása kötelező.',
    gradeError: 'Az osztálynak 1 és 12 közötti számnak kell lennie.',
    professorRequired: 'Tanár megadása kötelező.',
    languageRequired: 'Nyelv megadása kötelező.',
    selectSchool: 'Válasszon iskolát',
    confirmDeleteTitle: 'Törlés megerősítése',
    confirmDeleteMessage:
      'Biztos benne, hogy törölni szeretné ezt a bejegyzést? Ez a művelet végleges és visszavonhatatlan.',

    confirmButton: 'Megerősítés',
    confirmDelete:
      'Biztos benne, hogy törölni szeretné? Ez a művelet nem vonható vissza.',
    yes: 'Igen',
    no: 'Nem',
    pending: 'Függőben',
    resolved: 'Megoldva',
    successTitle: 'Siker',
    successMessage:
      'A panaszát sikeresen benyújtotta. Köszönjük, hogy értesített minket. A tanárok áttekintik a panaszt és megfelelő intézkedéseket tesznek. A panasz státuszáról a lehető leghamarabb értesítjük.',
    viewComplaintsButton: 'Összes panasz megtekintése',
    okButton: 'OK',
    resetPasswordTitle: 'Jelszó visszaállítása: {{user}}',
    resetPasswordInstruction:
      'Adjon meg egy új jelszót vagy generáljon véletlenszerűt a felhasználó számára.',
    newPassword: 'Új jelszó',
    generatePassword: 'Jelszó generálása',
    generatedPasswordInfo: 'Szükség esetén módosíthatja a generált jelszót.',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    passwordResetSuccess: 'A jelszó sikeresen visszaállítva.',
    passwordResetError:
      'Hiba történt a jelszó visszaállítása során. Kérjük, próbálja újra.',
    dateLabel: 'Dátum',
    classLabel: 'Osztály',
    complaintMessageLabel: 'Panasz üzenet',
    submitComplaint: 'Panasz benyújtása',
    complaintSubmissionDetails: 'A panasz benyújtásának részletei',
    ormTitle: 'Panasz benyújtási űrlap',
    editComplaint: 'Panasz szerkesztése',
    loadStudentsError: 'Hiba történt a diákok betöltésekor',
    saveError: 'Hiba történt a mentés során',
    saveButton: 'Mentés',
    schoolRead: 'Az iskola elolvasta',
    schoolUnread: 'Az iskola nem olvasta',
    formTitle: 'Panasz benyújtási űrlap',
    notInComplaintMode:
      'Jelenleg nem lehetséges panaszt benyújtani, mivel a panasz mód nincs aktiválva.',
    success: {
      complaintSubmitted: 'A panaszt sikeresen benyújtották.'
    },
    error: {
      missingFields: 'Hiányzó kötelező mezők.',
      fetchingStudents: 'Hiba történt a diákok lekérése során.',
      submittingComplaint: 'Hiba történt a panasz benyújtása során.',
      invalidEmail: 'Érvénytelen email címet adott meg.',
      studentRegistrationNotAllowed:
        'A diák regisztráció jelenlegi fázisban nem engedélyezett.'
    },
    close: 'Bezárás',
    editSchool: 'Iskola szerkesztése',
    name: 'Név',
    role: 'Szerep',
    remark: 'Megjegyzés',
    saveChanges: 'Változtatások mentése',
    addUser: 'Felhasználó hozzáadása',
    username: 'Felhasználónév',
    password: 'Jelszó',
    school: 'Iskola',
    notes: 'Megjegyzés',
    sendEmail: 'Email küldése a felhasználónak',
    save: 'Mentés',
    enterEmail: 'Adja meg az email címet, amellyel regisztrált.',
    email: 'Email',
    send: 'Küldés'
  },
  errors: {
    invalidEmail: 'Érvénytelen email címet adott meg.',
    required: 'Kötelező mező',
    locationMismatch:
      'A irányítószám és a város nem egyezik. Kérjük, javítsa az adatokat.',
    saveDataError: 'Hiba történt az adatok mentése során.',
    schoolNameMismatch:
      'Csak a saját iskolájához tartozó diákokat lehet hozzáadni. A fájlban szereplő iskola neve nem egyezik a bejelentkezett iskoláéval.',
    schoolNotExistWarning:
      'Az iskola nem létezik az adatbázisban. Új iskola lesz hozzáadva.',
    passwordLength: 'A jelszónak legalább 6 karakterből kell állnia',
    duplicateUserName: 'A felhasználónév már létezik.'
  },
  error: {
    missingFields:
      'Kérjük, válassza ki a panaszt benyújtani kívánt diákot, és adja meg a panasz üzenetet.',
    fetchingStudents: 'Hiba a diákok vagy panaszok lekérdezése közben.',
    complaintAlreadyExists: 'Ehhez a tanulóhoz már benyújtottak panaszt.',
    submittingComplaint: 'Hiba a panasz benyújtása közben.'
  },
  success: {
    complaintSubmitted: 'A panaszt sikeresen benyújtották'
  },
  login: {
    reqFields: 'Felhasználónév és jelszó megadása kötelező',
    reqistrationReq: 'Adja meg a kötelező mezőket',
    loginError: 'Helytelen jelszó és/vagy felhasználónév',
    registrationError:
      'Nem adta meg helyesen az iskola hivatalos email címét. Ha nincs hozzáférése, jelentse a problémát a kengur@dms.rs címre.',
    generalError:
      'A megadott felhasználónévvel már létezik iskola. Ha problémája van, írjon az kengur@dms.rscímre.',
    title: 'Határok Nélküli Kengur - Szerbia Matematikus Társasága',
    username: 'Felhasználónév',
    password: 'Jelszó',
    register: 'Regisztráció',
    forgotPassword: 'Elfelejtett jelszó',
    instructions: 'Bejelentkezési útmutató',
    signInButton: 'Bejelentkezés',
    signIn: 'Bejelentkezés',
    registerButton: 'Regisztrálás',
    noAccount: 'Nincs fiókja? Regisztráljon!',
    welcomeBack: 'Üdv újra!',
    welcomeBackText:
      'Adja meg a felhasználónevét és jelszavát a bejelentkezéshez!',
    selectCity: 'Válasszon várost',
    selectSchool: 'Válasszon iskolát',
    schoolName: 'Iskola neve',
    schoolStreet: 'Iskola utca',
    schoolTelephone: 'Iskola telefonszáma',
    teacher: 'Tanár',
    schoolEmail: 'Iskola emailje',
    useEmailForRegistration: 'Regisztráció email használata',
    signUpButton: 'Regisztrálás',
    registrationSuccess: 'Sikeres regisztráció',
    loginDataSentToEmail:
      'A jelszó és felhasználónév sikeresen elküldve az email címére',
    confirm: 'Megerősítés',
    enterEmail: 'Adja meg email címét:',
    emailRequired: 'Email cím megadása kötelező',
    resetEmailSent: 'Az útmutató email címe elküldve a jelszó visszaállításához'
  },
  columns: {
    id: 'ID',
    school: 'Iskola',
    location: 'Helyszín',
    accountNumber: 'Számlaszám',
    paymentDate: 'Fizetési dátum',
    statementNumber: 'Kivonat száma',
    student_num: 'Tanulók száma',
    remark: 'Megjegyzés',
    actions: 'Műveletek',
    name: 'Név',
    type: 'Típus',
    zipCode: 'Irányítószám',
    zipcode: 'Irányítószám',
    street: 'Utca',
    telephone: 'Telefonszám',
    email: 'Email',
    professor: 'Tanár',
    action: 'Művelet',
    gender: 'Nem',
    result: 'Eredmény',
    category: 'Kategória',
    class: 'Osztály',
    language: 'Nyelv',
    point_sum: 'Összpontszám',
    studentCount: 'Diákok száma',
    location: 'Kerület',
    school_id: 'Iskola ID',
    student_id: 'Diák ID',
    sender_name: 'Feladó neve',
    message: 'Üzenet',
    status: 'Státusz',
    school_read: 'Iskola olvasta',
    admin_read: 'Admin olvasta',
    date: 'Dátum',
    actions: 'Műveletek',
    schoolName: 'Iskola neve',
    cityName: 'Város neve',
    title: 'Panaszok áttekintése',
    school: 'Iskola',
    student: 'Diák',
    selectClass: 'Válasszon osztályt',
    admin_response: 'Admin válasza',
    userName: 'Felhasználónév',
    userPass: 'Jelszó',
    isAdmin: 'Adminisztrátor',
    userGroup: 'Felhasználói csoport',
    sessionID: 'Munkamenet ID',
    lastLog: 'Utolsó bejelentkezés',
    userRemark: 'Megjegyzés',
    question: 'Kérdés',
    lastMessageDate: 'Utolsó üzenet dátuma'
  },
  filter: {
    filters: 'Szűrők',
    export: 'Export',
    columns: 'Oszlopok',
    column: 'Oszlop',
    density: 'Sűrűség',
    print: 'Nyomtatás',
    exportCSV: 'CSV exportálása',
    hideAll: 'Mindent elrejt',
    showAll: 'Mindent megjelenít',
    addFilter: 'Szűrő hozzáadása',
    removeAll: 'Mindent eltávolít',
    linkOperator: 'Kapcsolat operátor',
    operator: 'Operátor',
    value: 'Érték',
    valueFilter: 'Szűrő érték',

    input: 'Bemenet',
    operatorAnd: 'És',
    contains: 'tartalmazza',

    operatorOr: 'Vagy',
    inputLabelAnd: 'Bemenet (És)',
    inputLabelOr: 'Bemenet (Vagy)',
    addFilterLabel: 'Szűrő hozzáadása',
    removeFilterLabel: 'Szűrő eltávolítása',
    clearFilters: 'Szűrők törlése',
    nameColumns: 'Oszlop neve',
    searchColumns: 'Oszlopok keresése',
    equals: 'egyenlő',
    startsWith: 'kezdődik',
    endsWith: 'végződik',
    isEmpty: 'üres',
    isNotEmpty: 'nem üres',
    isAnyOf: 'bármelyik',
    compact: 'Kompakt',
    standard: 'Standard',
    comfortable: 'Kényelmes',
    city: 'Város',
    school: 'Iskola'
  },
  search: {
    placeholder: 'Keresés...'
  },
  table: {
    noRows: 'Nincs adat a megjelenítéshez'
  },
  text: {
    welcomeHomePage: 'Üdvözöljük a kezdőoldalon',
    downloadReports: 'Jelentések letöltése',
    studentCountMessage: `{{count}} diákot regisztrált`,
    welcome: 'Üdvözlünk {{name}}',
    date: 'Dátum',
    studentCount: 'Regisztrált diákok száma',
    top5Students: 'Top 5 diák',
    importantDates: 'Fontos dátumok',
    polls: 'Szavazások',
    vote: 'Szavazás',
    reports: 'Jelentések',
    downloadReport: 'Jelentés letöltése',
    studentResults: 'Diákok eredményei',
    schoolPerformance: 'Iskola teljesítménye',
    youAreNotASchoolUser: 'Nem vagy bejelentkezve iskolai felhasználóként'
  },
  profile: {
    title: 'Profil',
    username: 'Felhasználónév',
    name: 'Név',
    email: 'Email',
    phone: 'Telefon',
    address: 'Cím',
    city: 'Város',
    school: 'Iskola',
    saveChanges: 'Változtatások mentése',
    changePassword: 'Jelszó módosítása',
    currentPassword: 'Jelenlegi jelszó',
    newPassword: 'Új jelszó',
    confirmNewPassword: 'Új jelszó megerősítése',
    passwordMismatch: 'A jelszavak nem egyeznek',
    passwordChangeSuccess: 'A jelszó sikeresen megváltozott',
    passwordChangeError: 'Hiba történt a jelszó megváltoztatása során',
    updateSuccess: 'A profil sikeresen frissítve',
    updateError: 'Hiba történt a profil frissítése során',
    cancel: 'Mégse',
    zipcode: 'Irányítószám',
    professor: 'Tanár',
    validationError: 'Ez a mező kötelező.',
    confirmPassword: 'Jelszó megerősítése'
  },
  results: {
    title: 'Eredmények',
    tabsLabel: 'Válasszon osztályt',
    allClasses: 'Minden osztály',
    grade: '{{grade}}. osztály',
    gender: 'Nem',
    all: 'Minden',
    male: 'Férfi',
    female: 'Nő',
    language: 'Nyelv',
    allLanguages: 'Minden nyelv',
    serbian: 'Szerb',
    english: 'Angol',
    points: 'Pontok',
    name: 'Név',
    grade1: 'Osztály',
    noStudents: 'Nincs diák regisztrálva ehhez az osztályhoz',
    noData: 'Nincs adat a megjelenítéshez',
    croatian: 'Horvát',
    hungarian: 'Magyar',
    latin: 'Szerb (Latin)',
    romanian: 'Román',
    studentsTable: 'Diákok táblázata',
    accessDenied:
      'Az eredményekhez való hozzáférés jelenleg nem lehetséges, mivel a verseny olyan fázisban van, amely ezt nem teszi lehetővé.',
    allSchools: 'Minden iskola',
    mySchool: 'Saját iskola'
  },
  statistic: {
    title: 'Nem szerinti statisztika',
    description: 'Nem szerinti statisztika áttekintése',
    averageResultTitle: 'Átlagos eredmény nem szerint',
    studentCountTitle: 'Diákok száma nem szerint',
    legend: 'Jelmagyarázat',
    male: 'Férfi',
    female: 'Nő',
    gender: 'Nem',
    value: 'Érték',
    noData: 'Nincs adat',
    resultStatistic: 'Eredmények statisztikája',
    generalOverview: 'Általános áttekintés',
    grade: 'Osztály',
    studentCount: 'Diákok száma',
    averageScore: 'Átlagos eredmény',
    lowestScore: 'Legalacsonyabb eredmény',
    highestScore: 'Legmagasabb eredmény',
    totalPoints: 'Összpontszám',
    noResultMode:
      'Jelenleg nem lehetséges az eredmények statisztikájának áttekintése.',
    maxScore: 'Legmagasabb eredmény',
    avgScore: 'Átlagos eredmény',
    studentCountByLanguage: 'Diákok száma nyelv szerint',
    languageTableTitle: 'Diákok száma nyelv szerint táblázat',
    language: 'Nyelv',
    totalCount: 'Összes szám',
    serbian: 'Szerb - Cirill',
    croatian: 'Horvát',
    hungarian: 'Magyar',
    latin: 'Szerb (Latin)',
    romanian: 'Román',
    pageTitle: 'Nyelvi statisztika',
    languages: {
      С: 'Szerb - Cirill',
      Х: 'Horvát',
      М: 'Magyar',
      Л: 'Szerb - Latin',
      Р: 'Román'
    }
  },
  snackbar: {
    deleteSuccess: 'A diák sikeresen törölve!',
    addSuccess: 'A diák sikeresen hozzáadva!'
  },
  statisticsByLanguage: {
    chartTitle: 'Diákok száma nyelv szerint',
    tableTitle: 'Diákok száma nyelv szerint táblázat',
    language: 'Nyelv',
    studentCount: 'Diákok száma',
    noData: 'Nincs adat'
  },
  alerts: {
    submissionClosed:
      'A regisztráció befejeződött, és jelenleg nem lehetséges diákokat hozzáadni vagy módosítani.',
    schoolDeleted: 'Az iskola sikeresen törölve.',
    schoolSaved: 'A módosítások sikeresen mentve.',
    studentAdded: 'A diák sikeresen hozzáadva!',
    studentDeleted: 'A diák sikeresen törölve.',
    studentsImported: 'A diákok sikeresen importálva'
  },
  headers: {
    enrolledStudents: 'Regisztrált diákok:',
    total: 'Összes',
    grade: '{{grade}}. osztály',
    userManagement: 'Felhasználókezelés'
  },
  complaints: {
    complaintAlreadyExistsTitle: 'A panasz már létezik',
    complaintAlreadyExistsMessage:
      'Ehhez a tanulóhoz már benyújtottak panaszt.',
    viewAllComplaints: 'Összes panasz megtekintése',
    noActiveMode:
      'Jelenleg nincs aktív mód a panaszok áttekintésére vagy benyújtására.',
    noCreateComplaints:
      'A panasz benyújtása jelenleg nem lehetséges, mivel a verseny olyan fázisban van, amely ezt nem teszi lehetővé.',
    noViewComplaints:
      'A panaszok áttekintése jelenleg nem lehetséges, mivel a verseny olyan fázisban van, amely ezt nem teszi lehetővé.',
    noViewStatisticsCondition:
      'Az eredmények statisztikájának áttekintése jelenleg nem lehetséges, mivel a verseny olyan fázisban van, amely ezt nem teszi lehetővé.',
    noComplaintsAllowed:
      'A panasz benyújtása a jelenlegi módban nem engedélyezett.',
    reviewPending:
      'Az áttekintés befejeződött, most már panaszokat nyújthat be.',
    canSubmitAndEdit:
      'Panaszokat nyújthat be, szerkesztheti és áttekintheti őket.',
    reviewOnly:
      'A panasz benyújtási határidő lejárt. Csak a meglévő panaszokat lehet áttekinteni.',
    noComplaintsInResultsMode: 'A panaszok nem elérhetők az Eredmények módban.',
    complaintDetails: 'Panasz részletei',
    professor: 'Tanár',
    noComplaints: 'Az iskola még nem nyújtott be panaszt',
    message: 'Üzenet',
    response: 'Kengur adminisztráció válasza',
    noResponse: 'Még nincs válasz',
    date: 'Dátum',
    administrator: 'Adminisztrátor',
    school: 'Iskola',
    mark_as_read: 'Válasz a panaszra',
    send_response: 'Válasz küldése',
    close: 'Bezárás',
    all: 'Összes',
    pending: 'Nem olvasott',
    responded: 'Olvasott',
    title: 'Panaszok',
    allComplaints: 'Minden panasz',
    unansweredComplaints: 'Meg nem válaszolt panaszok',
    finishedComplaints: 'Lezárt panaszok',
    worksButton: 'Munkák',
    studentInfo: 'Diák információ',
    acceptComplaint: 'Panasz elfogadása',
    sendResponse: 'Válasz küldése',
    markAsRead: 'Olvasottnak jelölés',
    send: 'Küldés',
    yourMessage: 'Üzeneted',
    acceptedComplaintMessage:
      'Tisztelt, az azonosítójú diák munkájával kapcsolatos panaszát elfogadtuk: {{studentId}}.',
    clickToView: 'Kattintson a panasz megtekintéséhez',
    tabsLabel: 'Panaszok áttekintése'
  },
  activeMode: 'Jelenleg aktív fázis:',
  modes: {
    FLAG_ZALBE: 'Panaszok',
    FLAG_REZULTATI_SKOLA_G: 'Áttekintés folyamatban',
    FLAG_REZULTATI: 'Előzetes eredmények',
    FLAG_FINALE: 'Végleges eredmények',
    FLAG_SAKRI_KLJUCEVE: 'Kulcsok elrejtése',
    FLAG_ZABRANA: 'Diák regisztráció tiltása',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Dolgozatok automatikus összekapcsolása'
  },
  noActiveMode: 'Regisztráció folyamatban',
  adminDashboard: {
    administration: 'Adminisztráció',
    students: 'Diákok',
    schools: 'Iskolák',
    locations: 'Helyszínek',
    competitionModes: 'Versenyfázisok',
    users: 'Felhasználók',
    categories: 'Kategóriák',
    complaints: 'Panaszok',
    passwordResetRequests: 'Jelszó visszaállítási kérelmek',
    solutionReports: 'Megoldási jelentések',
    results: 'Eredmények',
    reports: 'Jelentések',
    genderStatistics: 'Nem szerinti statisztika',
    languageStatistics: 'Nyelvi statisztika',
    resultsStatistics: 'Eredmények statisztikája',
    logout: 'Kijelentkezés',
    title: 'Vezérlőpult',
    studentsCount: 'Összes diák',
    total_students: 'Összes diák',
    manage_students: 'Diákok kezelése',
    schoolsCount: 'Összes iskola',
    total_schools: 'Összes iskola',
    manage_schools: 'Iskolák kezelése',
    complaintsNoResponse: 'Meg nem válaszolt panaszok',
    manage_complaints: 'Panaszok kezelése',
    current_competition: 'Jelenlegi versenyfázis',
    manage_competition: 'Verseny kezelése',
    students_by_class: 'Diákok száma osztály szerint',
    gender_distribution: 'Diákok nem szerinti statisztikája',
    recent_complaints: 'Legutóbbi benyújtott panaszok',
    pending_complaints: 'Meg nem válaszolt panaszok',
    current_mode: 'Jelenlegi fázis',
    mode_name: 'Fázis neve',
    status: 'Státusz',
    phase_competition: 'Verseny fázis',
    roles: 'Szerepek',
    homePage: 'Kezdőlap',
    review: 'Áttekintés',
    manageSolutions: 'Megoldások kezelése',
    reviewSchools: 'Munkák áttekintése',
    verifyReviews: 'Áttekintések ellenőrzése',
    resultsByGrade: 'Eredmények osztály szerint',
    other: 'Egyéb',
    profile: 'Profil'
  },
  roles: {
    title: 'Szerepek',
    searchPlaceholder: 'Szerepek keresése...',
    addNew: 'Új szerep hozzáadása',
    editTitle: 'Szerep szerkesztése',
    addTitle: 'Új szerep hozzáadása',
    nameLabel: 'Szerep neve',
    notesLabel: 'Megjegyzések',
    cancel: 'Mégse',
    save: 'Mentés',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    admin: 'Adminisztrátor',
    nastavnikPMF: 'PMF tanár',
    skola: 'Iskola',
    DMS: 'DMS'
  },
  adminModovi: {
    title: 'Versenyfázisok kezelése',
    subtitle: 'Versenyfázisok aktiválása vagy deaktiválása.',
    noDescription: 'Nincs elérhető leírás.',
    saveChanges: 'Változtatások mentése',
    fetchError: 'Hiba történt a fázisok lekérésekor:',
    updateError: 'A fázis módosítása sikertelen ID-val:',
    saveSuccess: 'Minden változtatás sikeresen mentve.',
    saveError: 'Hiba történt a változtatások mentésekor.',
    cleanArchiveButton: 'Archiválás és törlés',
    cleanDialogTitle:
      'Biztos benne, hogy mindent archiválni és törölni szeretne?',
    cleanDialogContent:
      'Minden adat archiválásra kerül, és az adatbázis táblák kiürülnek. Ez a művelet nem vonható vissza.',
    cancel: 'Mégse',
    confirm: 'Megerősít',
    cleanSuccess: 'Az adatok sikeresen archiválva és törölve.',
    cleanError: 'Hiba történt a törlési folyamat során.'
  },
  adminschool: {
    addNew: 'Új iskola hozzáadása',
    title: 'Iskolák adminisztrációja'
  },
  location: {
    zipcode: 'Irányítószám',
    area: 'Kerület',
    name: 'Név',
    actions: 'Műveletek',
    addLocation: 'Helyszín hozzáadása',
    locationDetails: 'Helyszín részletei',
    save: 'Mentés',
    locationUpdated: 'Helyszín frissítve',
    locationAdded: 'Helyszín hozzáadva',
    locationDeleted: 'Helyszín törölve',
    errorFetchingLocations: 'Hiba történt a helyszínek lekérésekor',
    errorSavingLocation: 'Hiba történt a helyszín mentésekor',
    errorDeletingLocation: 'Hiba történt a helyszín törlésekor',
    manageLocations: 'Helyszínek kezelése'
  },
  categories: {
    title: 'Kategóriák',
    searchPlaceholder: 'Kategóriák keresése…',
    addNew: 'Új kategória',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    editTitle: 'Kategória szerkesztése',
    addTitle: 'Új kategória hozzáadása',
    nameLabel: 'Kategória neve',
    notesLabel: 'Megjegyzés',
    cancel: 'Mégse',
    save: 'Mentés'
  },
  modeDescriptions: {
    FLAG_ZABRANA: 'A diákok regisztrációjának lezárása',
    FLAG_ZALBE: 'Panasz benyújtás engedélyezése',
    FLAG_REZULTATI_SKOLA_G: 'Áttekintés folyamatban',
    FLAG_REZULTATI: 'Előzetes eredmények',
    FLAG_FINALE: 'Végleges eredmények',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Dolgozatok automatikus összekapcsolása'
  },
  review: {
    deleteReview: 'Törölje az összes munkát a szerverről',
    grade: 'Osztály',
    clearAll: 'Mindent töröl',
    grade_suffix: 'osztály',
    notificationTitle: 'Értesítés',
    noAccessMessage: 'Nincs jogosultsága ezen oldal eléréséhez.',
    closeButton: 'Bezárás',
    student_count: 'Diákok száma',
    total_students: 'Összes diák száma',
    reviewed_students: 'Áttekintett diákok',
    unreviewed_students: 'Áttekintetlen diákok',
    competition_overview: 'Verseny áttekintése',
    unconnected_students: 'Kapcsolat nélküli diákok',
    connected_students: 'Kapcsolódott diákok',
    search_students: 'Diákok keresése',
    class: 'Osztály',
    movement: 'Mozgás',
    connect: 'Csatlakoztatás',
    disconnect: 'Leválasztás',
    previous: 'Előző',
    next: 'Következő',
    work: 'Munka',
    noUncheckedStudents: 'Nincsenek áttekintetlen diákok',
    noCheckedStudents: 'Nincsenek áttekintett diákok',
    no_more_works: 'Nincsenek további munkák a csatlakoztatáshoz',
    no_work_for_display: 'Nincsenek megjeleníthető munkák',
    disconnect_confirmation: 'Leválasztás megerősítése',
    disconnect_confirmation_message:
      'Biztos benne, hogy újra csatlakoztatni szeretné ennek a diák munkáját?',
    cancel: 'Mégse',
    success_connecting: 'Sikeres csatlakoztatás!',
    error_connecting: 'A csatlakoztatás sikertelen!',
    success_disconnecting: 'Sikeres leválasztás!',
    error_disconnecting: 'A leválasztás sikertelen!',
    error_occurred: 'Hiba történt!',
    work_number: '{{current}} a {{total}}-ból',
    id: 'ID',
    school_name: 'Iskola',
    scanned_works_count: 'Szkennelt munkák száma',
    connected_works_count: 'Csatlakoztatott munkák',
    action: 'Művelet',
    schools_with_works: 'Iskolák munkákkal',
    connecting_works: 'Munkák csatlakoztatása',
    connect_description: 'Itt kapcsolhatja a munkákat a diákokhoz.',
    'Povezivanje radova': 'Munkák csatlakoztatása',
    'Pregledanje u toku': 'Áttekintés folyamatban',
    'Završeno pregledanje': 'Áttekintés befejezve',
    'Provera pregledanja': 'Áttekintett munkák ellenőrzése',
    back: 'Vissza',
    finish: 'Befejezés',
    finishReview: 'Befejezés ellenőrzés',
    reset: 'Visszaállítás',
    all_steps_complete: 'Minden lépés befejeződött.',
    searchStudent: 'Diák keresése',
    studentExam: 'Diák vizsga',
    studentInfo: 'Diák információ',
    editStudentInfo: 'Módosítás',
    name: 'Név',
    school: 'Iskola',
    location: 'Helyszín',
    professor: 'Tanár',
    status: 'Státusz',
    working: 'Dolgozik',
    finished: 'Befejezett',
    text: 'Minden munkát ellenőriztél ebből az iskolából, befejezheted az ellenőrzést',
    opacity: 'Áttetszőség',
    points: 'Pontok',
    confirmReview: 'Áttekintés megerősítése',
    resetReview: 'Áttekintés visszaállítása',
    confirmResetTitle: 'Áttekintés visszavonása?',
    confirmResetMessage:
      'Biztos benne, hogy vissza szeretné vonni az összes változtatást?',
    yes: 'Igen',
    reviewResetSuccess: 'Áttekintés sikeresen visszaállítva!',
    reviewError: 'Hiba történt az áttekintés visszaállítása során.',
    refreshError: 'Hiba történt a diákok listájának frissítésekor.',
    tabs: {
      unreviewed: 'Áttekintetlen',
      reviewed: 'Áttekintett'
    },
    review: 'Áttekintés',
    db_points: 'Adatbázis pontok',
    currentViewer: 'Áttekintő',
    searchStudents: 'Diákok keresése',
    gender: 'Nem',
    male: 'Férfi',
    female: 'Nő',
    language: 'Nyelv',
    croatian: 'Horvát',
    serbian: 'Szerb',
    totalPoints: 'Összpontszám',
    address: 'Cím',
    changeSchoolData: 'Iskola adatok módosítása',
    changeStudentData: 'Diák adatok módosítása',
    studentWork: 'Diák munka',
    number: 'Szám',
    total: 'Összes',
    change: 'Módosítás',
    dialogTitle: 'Figyelmeztetés',
    finishedMessage:
      'Az iskola már át lett tekintve {{reviewer}} által. Ha folytatja, felülírhatja a meglévő eredményeket.',
    inProgressMessage:
      'Az iskolát jelenleg {{reviewer}} tekinti át. Ha folytatja, átfedések léphetnek fel.',
    unknownStatusMessage: 'Az iskola ismeretlen státusszal rendelkezik.',
    proceed: 'Folytatás',
    professor_name: 'Áttekintő',
    in_progress: 'Folyamatban',
    completed: 'Befejezett',
    not_started: 'Nem kezdődött el',
    schools: 'Iskolák szerint',
    grades: 'Osztályok szerint',
    schoolsTitle: 'Iskolák szerinti áttekintés',
    gradesTitle: 'Osztályok szerinti áttekintés',
    search: 'Keresés...',
    review_by_school_title: 'Áttekintett munkák ellenőrzése',
    connect_automatic: 'Automatikus összekapcsolás',
    automatic_connection_report: 'Automatikus összekapcsolási jelentés',
    connect_manually: 'Ручно повезивање',
    successfully_connected: 'Sikeresen összekapcsolva',
    failed_connections: 'Sikertelen összekapcsolások',
    failed_works: 'Sikertelen munkák',
    file: 'Fájl',
    reason: 'Ok',
    close: 'Bezár'
  },
  language: {
    latin: 'Szerb (Latin)',
    cyrillic: 'Szerb (Cirill)',
    hungarian: 'Magyar'
  },
  loading: {
    title: 'Betöltés...',
    description: 'Kérjük, várjon, amíg előkészítjük az adatokat'
  },
  statistics: {
    genderDistribution: 'Diákok nem szerinti statisztikája',
    studentByClass: 'Diákok száma osztály szerint',
    class: 'Osztály',
    numberOfStudents: 'Diákok száma',
    date: 'Dátum',
    studentCount: 'Diákok száma',
    grade: 'Osztály',
    averageScore: 'Átlagos eredmény',
    lowestScore: 'Legalacsonyabb eredmény',
    highestScore: 'Legmagasabb eredmény',
    totalPoints: 'Összpontszám',
    noViewStatisticsCondition: 'Jelenleg nem tekinthető át a statisztika',
    resultsByGrade: 'Eredmények osztály szerint'
  },
  solutions: {
    save: 'Mentés',
    cancel: 'Mégse',
    updatedSuccessfully: 'Sikeresen frissítve!',
    taskNumber: 'Szám',
    points: 'Pontok',
    letters: {
      A: 'A',
      B: 'B',
      V: 'V',
      G: 'G',
      D: 'D'
    },
    grade: 'Osztály',
    solutions: 'Megoldások',
    actions: 'Műveletek',
    errorFetchingSolutions: 'Hiba történt a megoldások lekérésekor'
  },
  button: {
    addUser: 'Felhasználó hozzáadása'
  },
  result: {
    title: 'Eredmények osztályok szerint',
    allCategories: 'Minden kategória',
    exportExcel: 'Excel exportálása',
    exportFiltered: 'Szűrt exportálás',
    resultsByGrade: 'Eredmények osztályok szerint',
    generatePDF: 'PDF generálása',
    gradeTabs: 'Osztályok tabok',
    name: 'Név',
    school: 'Iskola',
    place: 'Hely',
    points: 'Pontok',
    viewWork: 'Munka megtekintése',
    pdfFilename: 'Eredmények_osztaly_{{grade}}',
    grade: 'osztály',
    searchPlaceholder: 'Diákok keresése...'
  },
  resetPassword: {
    title: 'Jelszó visszaállítása',
    newPass: 'Új jelszó',
    confirm: 'Jelszó megerősítése',
    resetButton: 'Jelszó visszaállítása',
    passwordMismatch: 'A jelszavak nem egyeznek.',
    successMessage:
      'A jelszót sikeresen visszaállította. Átirányítjuk a kezdőlapra.',
    generalError: 'Hiba történt a jelszó visszaállítása során.',
    loading: 'Betöltés...',
    loadingButton: 'Kérjük, várjon...'
  },
  importStudentsDialog: {
    title: 'Diákok importálása',
    uploadPrompt: 'Töltse fel az Excel fájlt a diákok listájával:',
    schoolInfo: 'Iskola információk',
    studentsList: 'Diákok listája',
    schoolNotFound: 'Iskola nem található',
    noStudentsInExcel: 'Az Excel fájlban nincsenek diákok',
    schoolCanBeChanged:
      'Ha az Excel fájlban szereplő iskola nincs felismerve, válasszon megfelelő iskolát a listából, amelyhez hozzáadódnak a diákok az Excelből.'
  },
  student: {
    name: 'Név és vezetéknév',
    category: 'Kategória',
    grade: 'Osztály',
    language: 'Nyelv',
    gender: 'Nem'
  },
  school: {
    name: 'Iskola neve',
    street: 'Utca és szám',
    city: 'Város',
    zipcode: 'Irányítószám',
    teacher: 'Felelős tanár',
    phone: 'Telefonszám',
    email: 'Email'
  },
  buttons: {
    cancel: 'Mégse',
    save: 'Mentés',
    chooseFile: 'Fájl kiválasztása',
    noFileChosen: 'Nincs kiválasztva fájl'
  },
  messages: {
    studentsAdded: 'A diákok sikeresen hozzáadva.',
    canEditSchoolData: 'Szerkesztheti az iskola adatait.'
  },
  modals: {
    editPayment: 'Fizetés szerkesztése',
    addPayment: 'Fizetés hozzáadása'
  },
  validation: {
    futureDateError: 'A dátum nem lehet jövőbeli.',
    fixErrors: 'Javítsa ki a hibákat a folytatás előtt.'
  },
  form: {
    school: 'Iskola',
    accountNumber: 'Számlaszám',
    paymentDate: 'Fizetési dátum',
    statementNumber: 'Kivonat száma',
    note: 'Megjegyzés',
    location: 'Helyszín'
  },
  filters: {
    location: 'Válasszon helyszínt'
  },
  links: {
    downloadTemplate: 'Tanuló felvételi sablon letöltése'
  }
};
